import { action, observable, runInAction } from "mobx";
import { createViewModel, IViewModel } from "mobx-utils";
import { api } from "../../api";
import { IEmpresa } from "../../model";
import { toast } from "react-toastify";
import { AppStore } from "../AppStore";
import { EmpresaStore } from "../empresa/EmpresaStore";
import { PerfilStore } from "../perfil/PerfilStore";

export class _AssinaturaStore {

  obs = observable({
    empresa: {} as IEmpresa & IViewModel<IEmpresa>,
    valorTotal: 0 as number,
    qtyEmpresasSelect: 0 as number,
    cnpjs: [] as any[],
    progressIugu: false as boolean,
  })

  @action
  async handleIugu() {
    if (PerfilStore.obs.metodo_pagamento == "Boleto") {
      if (
        !PerfilStore.obs.plan_nome_completo || !PerfilStore.obs.plan_email ||
        !PerfilStore.obs.plan_telefone
      ) {
        this.obs.progressIugu = false;
        toast.error('Por favor, preencha todos os campos.', {});
        return;
      }
    }
    if (PerfilStore.obs.metodo_pagamento == "Cartao") {
      if (
        !PerfilStore.obs.plan_nome_cartao || !PerfilStore.obs.plan_cpf ||
        !PerfilStore.obs.plan_numero_cartao || !PerfilStore.obs.plan_cvv ||
        !PerfilStore.obs.plan_mes_cartao || !PerfilStore.obs.plan_ano_cartao
      ) {
        this.obs.progressIugu = false;
        toast.error('Por favor, preencha todos os campos.', {});
        return;
      }
    }
    try {
      let params = {
        metodo_pagamento: PerfilStore.obs.metodo_pagamento,
        nome_completo: PerfilStore.obs.plan_nome_completo,
        email: PerfilStore.obs.plan_email,
        telefone: PerfilStore.obs.plan_telefone,
        plan_nome_cartao: PerfilStore.obs.plan_nome_cartao,
        plan_cpf: PerfilStore.obs.plan_cpf,
        plan_numero_cartao: PerfilStore.obs.plan_numero_cartao,
        plan_cvv: PerfilStore.obs.plan_cvv,
        plan_mes_cartao: PerfilStore.obs.plan_mes_cartao,
        plan_ano_cartao: PerfilStore.obs.plan_ano_cartao,
      };

      let config = {};

      let resp = await api.post("/api/alter-plan", params, config);

      runInAction(() => {
        if (resp.data == "ok") {
          this.obs.progressIugu = false;
          toast.success('Operação realizada com sucesso!', {});
          setTimeout(function () {
            return AppStore.setLocation("/dashboard");
          }, 1000);
        } else {
          this.obs.progressIugu = false;
          toast.error('Erro ao processar os dados. Verifique todos os campos.', {});
        }
      });
    } catch (ex) {
      this.obs.progressIugu = false;
      toast.error(`Erro ao alterar Forma de Pagamento Fatura, tente novamente mais tarde.`, {});
    }
  }

  async handleAlteraDataVencimento(data: string) {

    try {

      let req = { data: data };

      let resp = await api.post("/api/muda-data-fatura", req);

      if (resp.data.ok) {

        toast.success('Data Alterada com sucesso.', {});

        PerfilStore.obs.formPlan = false

        await AppStore.loadUsuario()

      } else {

        toast.error(resp.data.error, {});

      }

    } catch (ex) {

      toast.error("Erro ao alterar Data de Vencimento Fatura, tente novamente mais tarde.", {});

    }

  }

  async handleAtivaPlano(params) {
    try {
      let resp = await api.post("/api/ativacao-plano", params);

      if (resp.data.ok) {
        toast.success('Plano ativado com sucesso.', {});
        setInterval(() => { window.location.href = "/dashboard" }, 2500)
      } else {
        toast.warning(resp.data.msg, {});
      }
    } catch (ex) {
      toast.error("Erro ao Ativar Plano, tente novamente mais tarde!", {});
    }
  }

}

export const AssinaturaStore = new _AssinaturaStore();
